import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73be5f23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = { class: "error-alert" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "导入结果: 整批导入失败", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "错误内容:", -1))
const _hoisted_5 = { style: {"justify-content":"center","display":"flex","margin":"10px"} }

import { ref, computed } from 'vue';
import {
  BaseButton,
  BaseTable,
  BaseTableProps,
  BaseInput,
  useTableColumn,
  XrkMessage,
  createDialog,
  XrkMessageBox
} from 'xrk-components';
import { downloadErrExcel, cancelImport } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-person-fail-table',
  props: {
    done: { type: Function, default: null },
    importCount: {},
    failCount: {},
    dataList: {},
    form: { default: () => ({
      excelCode: ''
    }) }
  },
  emits: ['againSubmit'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const currentPage = ref(1);
const pageSize = ref(15);

const emits = __emit;

const tableData = ref(props.dataList);
const isCellShow = ref(null);
const sizeSuccess = computed(() => {
  return `导入${props.importCount}条，失败${props.failCount}条`;
});

const excelErrorDownload = () => {
  downloadErrExcel({ excelCode: props.form.excelCode });
};

const tablePageData = ref(
  tableData.value.slice(
    (currentPage.value - 1) * pageSize.value,
    currentPage.value * pageSize.value
  )
);

const handleSizeChange = ({ currentPage, pageSize }) => {
  tablePageData.value = tableData.value.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
};
const columns: BaseTableProps['columns'] = [
  useTableColumn({
    label: '表格位置',
    prop: 'rowNumStr'
  }),
  useTableColumn({
    label: '姓名',
    prop: 'activityPeopleName',
    render: ({ row }) => {
      return isCellShow.value === 'activityPeopleName' + row.rowNum ? (
        <BaseInput
          placeholder="请输入姓名"
          ref="editInput"
          onInput={e => {
            row.activityPeopleName = e;
          }}
          v-model={row.activityPeopleName}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'activityPeopleName' + row.rowNum;
          }}
          type="text"
        >
          {row.activityPeopleName || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '手机号',
    prop: 'phone',
    render: ({ row }) => {
      return isCellShow.value === 'phone' + row.rowNum ? (
        <BaseInput
          type="tel"
          ref="editInput"
          placeholder="请输入手机号"
          onInput={e => {
            row.phone = e;
          }}
          v-model={row.phone}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'phone' + row.rowNum;
          }}
          type="text"
        >
          {row.phone || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '结算金额',
    prop: 'price',
    render: ({ row }) => {
      const inputRule = num => {
        let errMsg = '';
        if (+num > 90000) {
          errMsg = '输入数字不可大于90000';
          row.price = 90000;
        }
        if (errMsg) {
          createDialog({
            width: '300px',
            title: '提示',
            showClose: true,
            showFooter: false,
            content: errMsg
          });
          return;
        }
        row.price = num;
      };
      return isCellShow.value === 'price' + row.rowNum ? (
        <BaseInput
          ref="editInput"
          type="tel"
          maxlength={6}
          placeholder="请输入结算金额"
          onInput={e => {
            inputRule(e);
          }}
          v-model={row.price}
          onBlur={() => {
            isCellShow.value = '';
          }}
          onFocus={() => {
            inputRule(+row.price);
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'price' + row.rowNum;
          }}
          type="text"
        >
          {row.price || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '错误提示',
    width: '300px',
    render: ({ row }) => {
      return row.errorMsgList.map((item, index) => {
        return <p>{`${index + 1}.${item.errorMsg}`}</p>;
      });
    }
  }),
  useTableColumn({
    label: '操作',
    render: ({ index }) => {
      return (
        <BaseButton
          onClick={() => {
            XrkMessageBox.confirm('此操作将删除该项, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              tableData.value.splice(index, 1);
              tablePageData.value = tableData.value.slice(
                (currentPage.value - 1) * pageSize.value,
                currentPage.value * pageSize.value
              );
              XrkMessage({
                type: 'success',
                message: '删除成功!'
              });
            });
          }}
          type="text"
        >
          删除
        </BaseButton>
      );
    }
  })
];

async function onSubmit() {
  await XrkMessageBox.confirm('是否确认重新提交？');
  emits('againSubmit', {
    dataList: tableData.value
  });
  props.done();
}
const onCancel = async () => {
  await cancelImport({ excelCode: props.form.excelCode });
  props.done();
};

return (_ctx: any,_cache: any) => {
  const _component_BasePagination = _resolveComponent("BasePagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, " 信息校验结果: " + _toDisplayString(sizeSuccess.value), 1),
      _hoisted_3,
      _hoisted_4
    ]),
    _createVNode(_unref(BaseTable), {
      style: {"min-height":"300px"},
      ref: "baseTableRef",
      data: (tablePageData.value as any[]),
      columns: columns
    }, null, 8, ["data"]),
    _createVNode(_component_BasePagination, {
      "current-page": currentPage.value,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      "page-size": pageSize.value,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
      "page-sizes": [15, 60, 100],
      layout: "total, sizes, prev, pager, next, jumper",
      total: tableData.value.length,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleSizeChange
    }, null, 8, ["current-page", "page-size", "total"]),
    _createVNode(_unref(BaseButton), {
      onClick: excelErrorDownload,
      style: {"margin":"20px 0"}
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 下载错误Excel ")
      ]),
      _: 1
    }),
    _createElementVNode("span", _hoisted_5, [
      _createVNode(_unref(BaseButton), { onClick: onCancel }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        onClick: onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("重新提交")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})